import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=153a3b7f&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=153a3b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a3b7f",
  null
  
)

export default component.exports